import { WebSocketState } from './types/websocket.types';

export const websocketGetters = {
  getWorkerJob: (state: WebSocketState) => (jobId: number | null) =>
    Boolean(jobId) ? state.workerJobs.find(({ id }) => id === jobId) : null,
};
